import React from "react";

export default function ToggleBtn({onChange, checked, disabled}) {
  return (
    <div className="form-check form-switch">
      <input className="form-check-input cursor-pointer" type="checkbox" role="switch" checked={checked} onChange={onChange} disabled={disabled} />
    </div>
  );
}
